import React, { useState } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';

const SalesRepresentativeReport = () => {
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [showExportDropdown, setShowExportDropdown] = useState(false);
    const [activeSubTab, setActiveSubTab] = useState('sales-added');

    // Sub-tabs for the report
    const subTabs = [
        { id: 'sales-added', label: 'Sales Added', icon: 'fa-cog' },
        { id: 'sales-with-commission', label: 'Sales With Commission', icon: 'fa-cog' },
        { id: 'expenses', label: 'Expenses', icon: 'fa-cog' },
        { id: 'payments-with-commission', label: 'Payments with commission', icon: 'fa-cog' },
    ];

    // Mock data matching the screenshot
    const mockData = [
        {
            date: '03/05/2026 12:00 AM',
            invoiceNo: '',
            customerName: 'C&M Beer,',
            location: "Lefty'S Liquor",
            paymentStatus: 'Paid',
            totalAmount: '$ 12.15',
            totalPaid: '$ 12.15',
            totalRemaining: '$ 0.00'
        },
        {
            date: '03/04/2026 12:00 AM',
            invoiceNo: '',
            customerName: 'Aarbaz',
            location: "Lefty'S Liquor",
            paymentStatus: 'Paid',
            totalAmount: '$ 12.15',
            totalPaid: '$ 12.15',
            totalRemaining: '$ 0.00'
        },
        {
            date: '03/02/2026 12:00 AM',
            invoiceNo: '',
            customerName: 'Premium Brands,',
            location: "Lefty'S Liquor",
            paymentStatus: 'Paid',
            totalAmount: '$ 13.25',
            totalPaid: '$ 13.25',
            totalRemaining: '$ 0.00'
        },
        {
            date: '03/02/2026 12:00 AM',
            invoiceNo: '',
            customerName: 'Aarbaz',
            location: "Lefty'S Liquor",
            paymentStatus: 'Paid',
            totalAmount: '$ 12.15',
            totalPaid: '$ 12.15',
            totalRemaining: '$ 0.00'
        }
    ];

    const handleExport = (format) => {
        const headers = ['Date', 'Invoice No.', 'Customer name', 'Location', 'Payment Status', 'Total amount', 'Total paid', 'Total remaining'];
        const rows = mockData.map(r => [
            r.date || '',
            r.invoiceNo || '',
            r.customerName || '',
            r.location || '',
            r.paymentStatus || '',
            r.totalAmount || '$ 0.00',
            r.totalPaid || '$ 0.00',
            r.totalRemaining || '$ 0.00'
        ]);

        const title = 'Sales Representative Report';
        const filename = 'sales_representative_report';

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();

        setShowExportDropdown(false);
    };

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Summary Card ── */}
            <div style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                padding: '1.25rem 1.5rem',
                marginBottom: '1.5rem',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>
                <div style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '0.75rem', marginBottom: '1rem' }}>
                    <span style={{ fontWeight: '600', color: '#64748b', fontSize: '0.95rem' }}>Summary</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <div style={{ fontSize: '1.1rem', color: '#64748b' }}>
                        <span style={{ fontWeight: '400' }}>Total Sale - Total Sales Return: </span>
                        <span style={{ color: '#1e293b' }}>$ 1,000.32 - $ 0.00 = $ 1,000.32</span>
                    </div>
                    <div style={{ fontSize: '1.1rem', color: '#64748b' }}>
                        <span style={{ fontWeight: '400' }}>Total Expense: </span>
                        <span style={{ color: '#1e293b' }}>$ 0.00</span>
                    </div>
                </div>
            </div>

            {/* ── Sales Rep Table Container ── */}
            <div style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>

                {/* Sub-tabs */}
                <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#fff' }}>
                    {subTabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveSubTab(tab.id)}
                            style={{
                                padding: '1rem 1.25rem',
                                background: 'none',
                                border: 'none',
                                borderTop: activeSubTab === tab.id ? '2px solid #3b82f6' : '2px solid transparent',
                                color: activeSubTab === tab.id ? '#1e293b' : '#64748b',
                                fontWeight: activeSubTab === tab.id ? '700' : '600',
                                fontSize: '0.85rem',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                transition: 'all 0.2s',
                            }}
                        >
                            <i className={`fa ${tab.icon}`} style={{ fontSize: '0.9rem', color: activeSubTab === tab.id ? '#334155' : '#64748b' }} />
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* Table controls */}
                <div className="table-controls" style={{ borderBottom: '1px solid #e2e8f0', padding: '1rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select">
                            <span>Show</span>
                            <select value={entriesPerPage} onChange={e => setEntriesPerPage(Number(e.target.value))}>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>

                    <div className="table-controls-right">
                        {/* Single Export dropdown */}
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button
                                className="export-btn"
                                onClick={() => setShowExportDropdown(!showExportDropdown)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '0.4rem',
                                    padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0',
                                    borderRadius: '6px', background: '#fff', cursor: 'pointer',
                                    fontSize: '0.85rem', color: '#334155'
                                }}
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Export ▾
                            </button>
                            {showExportDropdown && (
                                <div className="export-dropdown-menu" style={{
                                    position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem',
                                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', zIndex: 10, minWidth: '160px'
                                }}>
                                    {[
                                        { icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport('CSV') },
                                        { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport('Excel') },
                                        { icon: 'fa-print', label: 'Print', action: () => handleExport('Print') },
                                        { icon: 'fa-table', label: 'Column visibility' },
                                        { icon: 'fa-file-pdf-o', label: 'Export PDF', action: () => handleExport('PDF') },
                                    ].map((item, i) => (
                                        <button
                                            key={i}
                                            onClick={() => { if (item.action) item.action(); else setShowExportDropdown(false); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.5rem',
                                                width: '100%', padding: '0.5rem 1rem', border: 'none',
                                                background: 'none', textAlign: 'left', cursor: 'pointer',
                                                fontSize: '0.8125rem', color: '#475569'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search ..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                width: '180px',
                            }}
                        />
                    </div>
                </div>

                {/* Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Date <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Invoice No. <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Customer name <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Location <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Payment Status <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Total amount <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Total paid <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Total remaining <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {mockData.map((row, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b' }}>{row.date}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b' }}>{row.invoiceNo}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.customerName}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.location}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem' }}>
                                        <span style={{
                                            background: '#4ade80', color: 'white', padding: '0.15rem 0.4rem',
                                            borderRadius: '4px', fontSize: '0.7rem', fontWeight: '600'
                                        }}>
                                            {row.paymentStatus}
                                        </span>
                                    </td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b' }}>{row.totalAmount}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b' }}>{row.totalPaid}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b' }}>{row.totalRemaining}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default SalesRepresentativeReport;
